import { z } from 'zod/mini'

export const mainRouteSchema = z.object({
  error: z.optional(z.string()),
})
